import { Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';
import { Subject } from 'rxjs';

@Injectable()
export class StorageService {
  public logout: Subject<any> = new Subject<any>();
  cookiesItems = [];

  getItem<T>(key: string): T {
    const result = localStorage.getItem(key);
    let resultJson = null;
    if (result != null) {
      resultJson = result;
    }
    return resultJson;
  }

  setItem<T>(key: string, value: T) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  setItemInCookies(key: string, value: string) {
    this.cookiesItems.push(key);
    const d = new Date();
    d.setTime(d.getTime() + AppSettings.COOKIE_EXPIRY);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = key + '=' + value + ';' + expires + ';path=/';
  }

  getItemFromCookies(key: string) {
    const name = key + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  removeItem<T>(key: string) {
    localStorage.removeItem(key);
  }

  removeAll<T>() {
    localStorage.clear();
  }

  removeAllCookies() {
    this.cookiesItems.forEach(key => {
      this.setItemInCookies(key, '');
    });
  }

  generateLocalToken(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}
